module.exports = __webpack_public_path__ + "static/media/india-flag.7e5be295.jpg";